import * as React from "react";
function SvgDevice(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
        d="M7 1h18v30H7z"
      />
      <circle cx={16} cy={26} r={2} />
      <path
        fill="none"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
        d="M10 5h7.99M20 5h2"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgDevice);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
